import React from 'react'
import { Button, Divider, Segment, Header, Grid } from 'semantic-ui-react'

import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";


const ClydeSanibel = () => (

    <React.Fragment>
    <Segment  style={{ padding: '0em 0em' }} vertical>
        <Grid celled='internally' columns='equal' stackable>
            <Grid.Row textAlign='center'>
                <Grid.Column  style={{ paddingBottom: '0em', paddingTop: '0em' }}>
                <br/>
                    <Header as='h3' style={{ fontSize: '2em' }}>Clyde on Sanibel Island <br/> (1911 - 1926) </Header>
                    <br/>
                </Grid.Column>
            </Grid.Row>
    
            <Grid.Row textAlign='left'>
                <Grid.Column  style={{ paddingBottom: '1em', paddingTop: '.5em' }} >
                    <p class="sidePadding" style={{ fontSize: '1.33em' }}>
                    <SimpleReactLightbox>
                        <SRLWrapper>
                    <br/>
                    Lucy Reed came to Sanibel with her father, Captain William Reed and her brother Will Reed and laid claim to 160 acres of land along San Carlos Bay in 1887.  Captain Reed had seen Sanibel Island when he served in the United States Navy during the Civil War.
                    <br/>
                    <br/>
                    Lucy married John Daniels in 1896.  They had three children, Bertha, JB, and Hack (Haskell).  John Daniels was killed by a drunken farmhand in 1907.  Lucy used the money she got from a good crop of peppers with some money her father loaned her to buy the Hughes Floating Hotel.  They heaved it ashore and renamed it the Sanibel House.  
                    <br/>
                    <br/>
                    In 1910 she married a local farmer, Oliver Richardson.  They had two sons, Clyde in 1911 and Frank in 1913.  Oliver dabbled in real estate and farmed.
                    <br/>
                    <br/>
                    As told by Clyde Richardson:
                    <br/>
                    <br/>
                    The Sanibel House was where he and his brothers and sister lived.  There was a pier in front.  Beside it was Grandpa’s house and next to that was Uncle Will’s house.
                    <br/>
                    <br/>
                    They bought their food at Bailey’s Store or by boat from Fort Myers.  They also fished a lot, hunted rabbits and clams.  The rest of what they ate was grown by Oliver. They attended a one room school house.  All grades were held there. Some grades had as little as two or three kids in them.  They would sit in different areas.  Grade by grade would go up front; the teacher would instruct them on their lesson and would go back to their space to do their lessons as the other grades took their turn.
                    <br/>
                    <br/>
                    They had to walk to school on roads that flooded during high tide.  A small bridge consisting of two 2X12’s were constructed so they could pass at high tide.
                    <br/>
                    <br/>
                    During non school days they spent a lot of time swimming.  They also used large whiskey bottle as boats.  On one occasion Clyde and Frank were playing cops and robbers.  Clyde picked up a gun on the porch and shot the bottom of Frank’s shoes off.  He hadn’t realized it was loaded.
                    <br/>
                    <br/>
                    The only time Clyde remembered getting whipped by his Father was when his Father was when his Father was going away for a while and told Clyde that he was to feed the mule.  He forgot and received a whipping.  Clyde said he never forgot again.
                    <br/>
                    <br/>
                    Clyde remembers riding in the back of a wagon drawn by a mule.  His Father had loaded some poison oats in the wagon.  A second mule was tethered to the back.  The tethered mule came up and started eating the oats.  Clyde, not having been told the oats were poison let him; His dad (Oliver) jammed lard up the mule’s rear in ordered to save it.  Though Clyde was not sure why his father did this, the mule did live.
                    <br/>
                    <br/>
                    Clyde remembers a hurricane flooding the hotel and leaving water marks on the walls and furniture.
                    <br/>
                    <br/>
                    The mosquitoes were very populous.  The Richardson’s kept a smoke pot at the front door to keep them away.  You could put your hand on the screen, leave it there and when you pulled it away there would be your handprint on the screen in mosquitoes.
                    <br/>
                    <br/>
                    Clyde learned to drive at a young age and was allowed to drive to Bailey’s Store, which was about a mile away.  Once he drove on the beach and got the truck stuck in the sand.  They had to wait until the tide went out and use mules to pull it out.
                    <br/>
                        </SRLWrapper>
                    </SimpleReactLightbox>
                    </p>
                </Grid.Column>
            </Grid.Row>
            </Grid>
        </Segment>
    </React.Fragment>
)

export default ClydeSanibel